import React from "react";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../stores/calculateStore";
import { ValidatedValue } from "../../../helpers/validator";
import TextInput from "../textInput/textInput";

interface RegonProps {
    calculateStore?: CalculateStore;
    value: ValidatedValue<string>;
    recalculate?: boolean;
    disabled?: boolean;
}

export function Regon(props: RegonProps) {
    const calculateStore = props.calculateStore!;
    const recalculateOnChange = props.recalculate ?? false;

    return (
        <div className="regon">
            <div className="question-answer-container">
                <div className="question">REGON</div>
                {renderRegon()}
            </div>
        </div>
    );

    function renderRegon() {
        const regonLength: number = 9;

        return (
            <div className="regon-container">
                <TextInput
                    disabled={props.disabled}
                    validatedValue={props.value}
                    onChange={(value) => {
                        props.value.setValue(value);
                        if (recalculateOnChange) {
                            calculateStore.setRequireRecalculate(true);
                            calculateStore.setRequireRecalculatePackages();
                        }
                    }}
                    onlyNumberValue={true}
                    topLabel="REGON"
                    maxLength={regonLength}
                />
            </div>);
    }
}

export default inject("calculateStore")(observer(Regon));
